import { replace } from 'react-router-redux';

import * as CheckoutHelper from 'helper/checkout';
import * as InvoiceRepository from 'repositories/invoice';

import { LayoutActionCreators } from 'actions/layout';
import { ROUTE_CHECKOUT_ERROR } from 'constants/app';
import { ActionCreator } from 'helper/redux';
import { Invoice } from 'models/invoice';
import { Thunk } from 'models/redux';

export const CheckoutActionCreators = {
  updateInvoiceDetail: new ActionCreator<'checkout/UpdateInvoiceDetail', Invoice>('checkout/UpdateInvoiceDetail')
};

export function previewInvoiceDetail(invoiceId: string): Thunk {
  return (dispatch) => {
    dispatch(LayoutActionCreators.showLoading.create());
    return InvoiceRepository.getDetail(invoiceId)
      .then((invoice) => {
        dispatch(CheckoutActionCreators.updateInvoiceDetail.create(invoice));
        dispatch(LayoutActionCreators.hideLoading.create());
      })
      .catch((e) => {
        dispatch(replace(ROUTE_CHECKOUT_ERROR));
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}

export function startCheckoutPage(invoice: Invoice): Thunk {
  return (dispatch) => {
    if (invoice.payment && new Date(invoice.payment.timeoutTime) >= new Date()) {
      CheckoutHelper.checkout
        .open(invoice.payment.referenceNo, { name: invoice.recipient.name });
    } else {
      dispatch(LayoutActionCreators.showLoading.create());
      InvoiceRepository.createPayment(invoice)
        .then((payment) => {
          dispatch(CheckoutActionCreators.updateInvoiceDetail.create({ ...invoice,  payment }));
          CheckoutHelper.checkout
            .open(payment.referenceNo, { name: invoice.recipient.name });
        });
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/checkout.ts